import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

export interface RadarDataResponse {
  labels: string[];
  values: number[];
}

export interface DimensionReport {
  criticalIssues: string[];
  improvementAreas: string[];
}

export interface CompanyAggregatedReport {
  inclusionIndex: number;
  inclusionLevel: string;
  letterGrade: string;
  summaryDescription: string;
  dimensionScores: Record<string, number>;
  dimensionTranslationKeys?: Record<string, string>;
  dimensions: Record<string, DimensionReport>;
  allQuestionScores: number[];
}

export interface CompanyReportResponse {
  companyId: number;
  companyName: string;
  lastSubmissionDate: string | null;
  selfAssessmentReport: CompanyAggregatedReport;
}

@Injectable({
  providedIn: 'root'
})
export class ReportService {

constructor(private http: HttpClient) {}

  getRadarData(): Observable<RadarDataResponse> {
    return this.http.get<RadarDataResponse>('/api/radar-data');
  }


  getReport(): Observable<CompanyReportResponse> {
    const token = localStorage.getItem('token');

    const headers = {
      Authorization: `Bearer ${token}`
    };

    return this.http.get<CompanyReportResponse>(environment.apiUrl + `/api/companies/report`,{headers});
  }

}
